export default __webpack_public_path__ + "static/media/slide_crece_mobile.59c874a1.png";